module.exports = __webpack_public_path__ + "img/redMice.aa7baf1a.svg";